import React, { FC } from "react";
import { faSparkles } from "@fortawesome/pro-regular-svg-icons/faSparkles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Sparkles: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faSparkles} {...props} />
);
